import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import HelmetMetaData from "./HelmetMetaData/HelmetMetaData";

export default function Contact() {
  const { register, handleSubmit, errors, reset } = useForm();
  const [organizationData, setOrganizationData] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    axios
      .get("api/home/get_organization_data", { signal: controller.signal })
      .then((res) => {
        if (!isMounted) return;
        if (res.data.status == "success") {
          setOrganizationData(res.data.data);
        } else {
          setOrganizationData([]);
        }
      })
      .catch((error) => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load organization data:", error);
        }
      });

    window.scrollTo(0, 0);

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const submitContactForm = (value) => {
    axios.post("/api/save_contact", value).then((resp) => {
      if (resp.data.status == "success") {
        $("#messages").html(resp.data.message);
        $("#messages").addClass("alert alert-success");
        reset({
          fullname: "",
          mobile_no: "",
          message: "",
          subject: "",
          email: "",
        });
      } else {
        $("#messages").html(resp.data.message);
        $("#messages").addClass("alert alert-danger");
      }
      setTimeout(() => {
        $("#messages").html("");
        $("#messages").removeClass("alert alert-danger alert-success");
      }, 4000);
    });
  };

  return (
    <React.Fragment>
      <HelmetMetaData />

      <div className="sf-cp-page">

        {/* ── Page Header ── */}
        <div className="sf-cp-page-header">
          <h1 className="sf-cp-page-title">Contact Us</h1>
          <p className="sf-cp-page-subtitle">
            We're here to assist you — connect with us!
          </p>
        </div>

        {/* ── Main Content ── */}
        <div className="sf-cp-main">
          <div className="sf-cp-layout">

            {/* ── Form Card ── */}
            <div className="sf-cp-form-card">
              <h2 className="sf-cp-form-heading">Get in Touch</h2>

              <form
                className="sf-cp-form"
                onSubmit={handleSubmit(submitContactForm)}
                method="post"
              >
                <div className="sf-cp-field">
                  <label className="sf-cp-label">
                    Full Name <span className="sf-cp-required">*</span>
                  </label>
                  <input
                    name="fullname"
                    type="text"
                    required
                    className="sf-cp-input"
                    placeholder="Please Enter Your Full Name"
                    ref={register({ required: "Required" })}
                  />
                </div>

                <div className="sf-cp-field">
                  <label className="sf-cp-label">
                    Email <span className="sf-cp-required">*</span>
                  </label>
                  <input
                    name="email"
                    type="email"
                    className="sf-cp-input"
                    required
                    placeholder="Please Enter Your Email"
                    ref={register({
                      required: "Required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid Email Address",
                      },
                    })}
                  />
                </div>

                <div className="sf-cp-field">
                  <label className="sf-cp-label">
                    Phone Number <span className="sf-cp-required">*</span>
                  </label>
                  <input
                    name="mobile_no"
                    type="text"
                    className="sf-cp-input"
                    required
                    placeholder="Please Enter Your Phone Number"
                    ref={register({ required: "Required" })}
                  />
                </div>

                <div className="sf-cp-field">
                  <label className="sf-cp-label">
                    Subject <span className="sf-cp-required">*</span>
                  </label>
                  <input
                    name="subject"
                    type="text"
                    className="sf-cp-input"
                    required
                    placeholder="Please Enter Subject"
                    ref={register({ required: "Required" })}
                  />
                </div>

                <div className="sf-cp-field">
                  <label className="sf-cp-label">
                    How may we assist You? <span className="sf-cp-required">*</span>
                  </label>
                  <textarea
                    name="message"
                    className="sf-cp-input sf-cp-textarea"
                    rows="4"
                    placeholder="Write your message..."
                    ref={register({ required: "Required" })}
                  ></textarea>
                </div>

                <div id="messages"></div>

                <button type="submit" className="sf-cp-submit-btn">
                  Send Message
                </button>
              </form>
            </div>

            {/* ── Right Sidebar ── */}
            <div className="sf-cp-sidebar">

              {/* Contact Information */}
              <div className="sf-cp-info-card">
                <h3 className="sf-cp-widget-title">Contact Information</h3>

                <div className="sf-cp-info-item">
                  <div className="sf-cp-info-icon sf-cp-icon-blue">
                    <i className="ri-phone-line"></i>
                  </div>
                  <div className="sf-cp-info-detail">
                    <span className="sf-cp-info-label">Phone Number</span>
                    <span className="sf-cp-info-value">{organizationData.phone}</span>
                    {organizationData.mobile && (
                      <span className="sf-cp-info-value">{organizationData.mobile}</span>
                    )}
                  </div>
                </div>

                <div className="sf-cp-info-item">
                  <div className="sf-cp-info-icon sf-cp-icon-yellow">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div className="sf-cp-info-detail">
                    <span className="sf-cp-info-label">Email</span>
                    <a
                      href={`mailto:${organizationData.email}`}
                      className="sf-cp-info-value sf-cp-info-link"
                    >
                      {organizationData.email}
                    </a>
                  </div>
                </div>

                <div className="sf-cp-info-item">
                  <div className="sf-cp-info-icon sf-cp-icon-blue">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div className="sf-cp-info-detail">
                    <span className="sf-cp-info-label">Address</span>
                    <span className="sf-cp-info-value">
                      {organizationData.address1}
                      {organizationData.address2
                        ? `, ${organizationData.address2}`
                        : ""}
                    </span>
                  </div>
                </div>
              </div>

              {/* Business Hours */}
              <div className="sf-cp-hours-card">
                <h3 className="sf-cp-widget-title">Business Hours</h3>
                <div className="sf-cp-hours-item">
                  <span className="sf-cp-hours-days">Sunday - Friday</span>
                  <span className="sf-cp-hours-time">9:30 am - 5:30 pm</span>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* ── Map ── */}
        <div className="sf-cp-map-wrap">

          <iframe src={organizationData.google_map_code}
          height="420"  
          allowfullscreen="" 
          loading="lazy" 
          referrerpolicy="no-referrer-when-downgrade">
          </iframe>

        </div>

      </div>
    </React.Fragment>
  );
}


